import React from "react";
import { Link } from "react-router-dom";

function Sidebar() {
  return (
    <aside className="sidebar">
      <ul>
        <li><Link to="/dashboard">Overview</Link></li>
        <li><Link to="/dashboard/users">Users</Link></li>
        <li><Link to="/dashboard/chargers">Chargers</Link></li>
        <li><Link to="/dashboard/sessions">Sessions</Link></li>
        <li><Link to="/dashboard/transactions">Transactions</Link></li>
        <li><Link to="/dashboard/notifications">Notifications</Link></li>
        <li><Link to="/ocpp/status">OCPP Status</Link></li>
      </ul>
    </aside>
  );
}

export default Sidebar;
